<template>
    <v-card outlined>
        <v-card-title class="primary--text">My Profile</v-card-title>
        <v-card-text class="d-flex">
            <v-avatar size="120">
                <img :src="authUser.medium_profile_photo_url" />
            </v-avatar>
            <div class="ml-4">
                <h2 class="mb-1">{{ authUser.name }}</h2>
                <h5>
                    <v-icon small class="mr-1">mdi-domain</v-icon
                    >{{ authUser.company.name }}
                </h5>
                <h5>
                    <v-icon small class="mr-1">mdi-email</v-icon
                    >{{ authUser.email }}
                </h5>
                <h5 v-if="$_.get(authUser, 'contact.phone', '')">
                    <v-icon small class="mr-1">mdi-phone</v-icon
                    >{{ authUser.contact.phone }}
                </h5>
            </div>
        </v-card-text>
        <v-card-actions class="mr-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{ name: 'Account Profile' }">
                <v-icon class="mr-2">mdi-account-circle</v-icon>Edit My Profile
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "profile-card",
};
</script>

<style lang="scss" scoped>
</style>